/**
 *  Простой класс-контейнер для передачи данных через механизм эммиттеров событий.
 *  @publicApi
 */
export class DxAppEvent {
  /**
   * Строковый идент объекта-источника события.
   * @name _source
   * @type {string}
   * @readonly
   */
  private readonly _source: string;

  /**
   * Таймстэмп момента создания события (временная метка).
   * @name _timestamp
   * @type {number}
   * @readonly
   */
  private readonly _timestamp: number;

  /**
   * Данные, переданные с событием.
   * @name _data
   * @type {any}
   * @readonly
   */
  private readonly _data: any;

  /**
   * Создает инстанс события.
   * @constructor
   * @param {string} source - cтроковый идент объекта-источника события.
   * @param {any} data - данные, переданные с событием (Опциональный параметр).
   */
  constructor(source: string, data?: any) {
    this._source = source;
    this._data = data;
    this._timestamp = new Date().getTime();
  }

  /**
   * Возвращает строковый идент объекта-источника события.
   * @public
   * @return {string} - строковый идент объекта-источника события.
   */
  get source(): string {
    return this._source;
  }

  /**
   * Возвращает таймстэмп момента создания события (временная метка).
   * @public
   * @return {number} - таймстэмп момента создания события (временная метка).
   */
  get timestamp(): number {
    return this._timestamp;
  }

  /**
   * Возвращает данные, переданные с событием.
   * @public
   * @return {any} - данные, переданные с событием.
   */
  get data(): any {
    return this._data;
  }
}
